import React from "react";
import classes from "./Static.module.css";
import StaticHeader from "./StaticHeader";
import pricingAndRoyaltiesAnimation from "../../assets/staticScreenAnimation/pricing-and-royalties.json";
import Divider from "../../components/Divider/Divider";
import StaticContent from "./StaticContent";
import BackButton from "../../components/Buttons/BackButton";
import MainFooter from "../../components/MainFooter/MainFooter";
import Utils from "../../Utils";

const content = [
  {
    title: "Book Price Calculator",
    description: [
      <>
        <div className={classes.tableWrapper}>
          <table className={classes.bookPriceTable}>
            <thead>
              <tr>
                <th className={classes.pages}>Total no. of Book Pages</th>
                <th className={classes.centerCellHeading}>
                  Front and Back cover
                </th>
                <th className={classes.centerCellHeading}>Binding</th>
                <th className={classes.price}>MRP</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={classes.tableCell}>24-32</td>
                <td className={classes.tableCell}>4 Page</td>
                <td className={classes.tableCell}>Center Pin</td>
                <td className={classes.tableCell}>350</td>
              </tr>
              <tr>
                <td className={classes.tableCell}>40-48</td>
                <td className={classes.tableCell}>4 Page</td>
                <td className={classes.tableCell}>Center Pin</td>
                <td className={classes.tableCell}>375</td>
              </tr>
              <tr>
                <td className={classes.tableCell}>48-64</td>
                <td className={classes.tableCell}>4 Page</td>
                <td className={classes.tableCell}>Perfect</td>
                <td className={classes.tableCell}>400</td>
              </tr>
              <tr>
                <td className={classes.tableCell}>64 & Above </td>
                <td className={classes.tableCell}>4 Page</td>
                <td className={classes.tableCell}>Perfect</td>
                <td className={classes.tableCell}>400 + 3 per extra page</td>
              </tr>
            </tbody>
          </table>
        </div>
      </>,
      <p className={classes.italicPara}>
        1. Every Book must include a page count which should be a multiple of 8.
      </p>,
      <p className={classes.italicPara}>
        2. If a book exceeds 64 pages, an additional Rs 3 per page charge will
        apply.
      </p>,
      <p className={classes.italicPara}>
        3. Royalties are only paid for books sold on the Bookalooza platform; sales
        on Amazon, Flipkart, or any other marketplace do not qualify.
      </p>,
      <p className={classes.italicPara}>
        4. Book pricing is revised annually on March 31st.
      </p>,
    ],
  },
  {
    title: "Disclaimer",
    description: [
      `The company provides its services "as is" and "as available," without any guarantees or warranties, express or implied. We do not ensure accuracy, reliability, completeness, security, or uninterrupted availability. Use of our services is at your own risk. To the fullest extent permitted by law, we disclaim all warranties, including merchantability, non-infringement, and fitness for a particular purpose.`,
    ],
  },
];

function PricingAndRoyalties() {
  return (
    <>
      <div className={classes.main}>
        <div className={classes.backButtonWrapper}>
          <BackButton className={classes.backButton} />
        </div>
        <div className={classes.container}>
          <StaticHeader
            title={"Pricing And Royalties"}
            description={"Read our terms below to learn more"}
            animation={pricingAndRoyaltiesAnimation}
          />
          <Divider style={{ marginBottom: "2rem" }} />
          <div className={classes.contentWrapper}>
            {content?.map((item, idx) => {
              return (
                <StaticContent
                  key={idx}
                  title={item.title}
                  description={item.description}
                />
              );
            })}
          </div>
        </div>
      </div>
      <MainFooter />
    </>
  );
}

export default PricingAndRoyalties;
